export enum NotificationEvent {
    // Purchase-related events
    ITEM_PURCHASED = 1, // To Seller, when their item(s) are purchased.
    ITEM_TRANSFERRED = 14, // To Buyer, when an item is transferred.

    // Admin-related events
    BLOCKED = 2, // Blocked by admin.
    UNBLOCKED = 3, // Unblocked by admin.

    // Loan-related events
    LENDING_AMOUNT_REPAID = 4, // To Lender, when lending amount is repaid by the borrower.
    LOAN_FORECLOSED = 5, // To Borrower, when the loan is foreclosed.
    LENDER_ACCEPTED_LOAN_REQUEST = 6, // To Borrower, when lender accepts the loan request.
    LENDER_COUNTER_OFFER = 7, // To Borrower, when a lender gives a counter offer.
    BORROWER_ACCEPT_COUNTER = 8, // To Lender, when a borrower accepts the counter offer.
    BORROWER_RECOUNTER_OFFER = 9, // To Lender, when a borrower gives a re-counter offer.
    LENDER_ACCEPT_RECOUNTER = 10, // To Borrower, when a lender accepts the re-counter offer.
    LENDER_RECOUNTER_OFFER = 12, // To Borrower, when a lender gives a re-counter offer.
    BORROWER_ACCEPT_RECOUNTER = 13, // To Lender, when a borrower accepts the re-counter offer.
    FORECLOSE_SUCCESS = 29, // To Sender, when the loan is successfully foreclosed.
    LOAN_DEFAULTED = 30, // To Lender, when the loan is defaulted.
    LOAN_DEFAULTED_NOTIFICATION_TO_BORROWER = 31, // To Borrower, when their loan is defaulted.
    LOAN_OFFER_RECEIVED = 32, // To Lender, when a new loan offer is received.
    LOAN_OFFER_CREATED = 33, // To Borrower, when a lender creates a loan offer.
    REVISED_LOAN_BID_RECEIVED = 34, // To Lender, when a revised loan bid is received.
    LOAN_BID_APPROVED = 35, // To Lender, when their loan bid is approved.
    LOAN_BID_APPROVED_NOTIFICATION_TO_OWNER = 36, // To Owner, when they approve a loan bid.
    LOAN_BID_CANCELLED = 37, // To Lender, when a borrower cancels their loan bid.
    BORROWER_UPDATE_OFFER = 52,//borrower update their counter offer.
    LENDER_UPDATE_OFFER = 53,//lender update their counter offer.
    BORROWER_CANCELLED_OFFER = 54,//borrower cancell their counter offer.
    LENDER_CANCELLED_OFFER = 55,//lender cancell their counter offer.
    BORROWER_UPDATED_OPEN_OFFER = 56,//Borrower update their open loan counter offer
    LENDER_UPDATED_OPEN_OFFER = 57,///Lender update their open loan counter offer
    BORROWER_CANCELLED_OPEN_OFFER = 58,//Borrower cancel their open loan counter offer
    LENDER_CANCELLED_OPEN_OFFER = 59, //Lender cancell their open loan counter offer

    // Bid-related events
    BID_RECEIVED = 17, // To Seller/Borrower, when a bid is received.
    REVISED_BID_RECEIVED = 18, // To Seller, when a revised bid is received.
    BID_CANCELLED = 19, // To Buyer, when their bid is cancelled.
    BID_APPROVED = 20, // To Buyer, when their bid is approved.
    BID_APPROVED_NOTIFICATION_TO_SELLER = 21, // To Seller, when they approve a bid.
    BID_SUBMITTED = 22, // To Buyer, when they submit a bid.
    REVISED_BID_SUBMITTED = 23, // To Buyer, when their bid is revised.
    BID_CANCELLED_NOTIFICATION_TO_SELLER = 24, // To Seller, when they cancel a bid.
    BID_RECEIVED_FOR_FORECLOSED_NFT = 38, // To Seller/Lender, when a bid is received for a foreclosed NFT.
    BID_FAILED = 40, //To Bidder, when bid acceptance failed due to Insufficient funds.

    // Delivery-related events
    DELIVERY_REQUEST_SENT = 25, // To User, when they send a delivery request.
    DELIVERY_REQUEST_RECEIVED = 26, // To Admin, when a delivery request is received.
    DELIVERY_REQUEST_UPDATED = 27, // To Admin, when a delivery request is updated.
    DELIVERY_REQUEST_CANCELLED = 28, // To Admin, when a delivery request is cancelled.
    DELIVERY_REQUEST_CANCELLED_USER = 39, // To User, when a delivery request is cancelled.

    // Reminder-related events
    REMINDER_70_PERCENT_DUE = 11, // Reminder for 70% due.
    REMINDER_24_HOURS_DUE = 15, // Reminder for 24 hours due.
    REMINDER_90_PERCENT_DUE = 16, // Reminder for 90% due.
    REMINDER_50_PERCENT_DUE = 65, // Reminder for 50% due (cron; payload has no loan id).

    // Loan acceptance failures (insufficient balance)
    LOAN_REQUEST_BID_ACCEPTANCE_FAILED = 41, // To lender, when accepting their loan request failed.
    LOAN_BID_ACCEPTANCE_FAILED = 42, // To lender, when accepting their loan bid failed (payload has no loan id).

    //OPEAN LOAN OFFER EVENTS
    COUNTER_REQUEST_OPEN_LOAN_OFFER = 43,
    BULK_LOAN_BID_APPROVED = 44, //If the Lender/Owner accept the loan offer.
    BULK_LOAN_BID_APPROVED_NOTIFICATION_TO_OWNER = 45, //Send the notification to owner if the lender accept the counter offer.
    BULK_LOAN_BID_CANCELLED = 46, //Lender cancel the open loan offer.
    REVISED_BULK_LOAN_BID_RECEIVED = 47,//Lender update the open loan offer.
    LENDER_CREATED_A_BULK_LOAN_OFFER = 48,//If the lender create the open loan offer.
    OWNER_CANCELLED_LOAN_OFFER = 49, //if the owner cancel the bulk loan offer.
    BID_CANCELLED_DUE_TO_OTHER_ACCEPTANCE = 50, //To Bidder, when bid acceptance failed due to other acceptance.
    FUND_RECEIVED = 51, // when the fund is received.
    LOAN_INSTALLMENT_DUE_REMINDER =60, //LOAN INSTALLMENT DUE REMINDER
    LOAN_INSTALLMENT_PAYMENT_CONFIRMATION=61, //LOAN INSTALLMENT PAYMENT CONFIRMATION
    LOAN_REFINANCED=62, //LOAN REFINANCED SUCCESSFULLY
    LOAN_REPAID_VIA_REFINANCE=63, //LOAN REPAID VIA REFINANCE
    REFINANCE_LOAN_ACTIVATED =64, //REFINANCE LOAN ACTIVATED
    BUYER_COUNTER_OFFER =66, //BUYER COUNTER OFFER
    BUYER_RECOUNTER_OFFER =67, //BUYER RECOUNTER OFFER
    SELLER_RECOUNTER_OFFER=68, //SELLER RECOUNTER OFFER
    UPDATE_SELL_COUNTER_OFFER =69, //UPDATE SELL COUNTER OFFER
    CANCEL_SELL_COUNTER_OFFER=70, //CANCEL SELL COUNTER_OFFER
    LOAN_LENDER_CHANGED=71, //LOAN LENDER CHANGED
    LOAN_SOLD = 72, //LOAN SOLD
    LOAN_ASSIGNED=73, //LOANASSIGNED
    REFINANCE_AMOUNT_INSUFFICIENT_TO_LENDER=74, // Refinance amount insufficient if borrower accept the refinance counter
    REFINANCE_AMOUNT_INSUFFICIENT_TO_BORROWER=75, // Refinance amount insufficient if lender accept the refinance request
    KYC_VERIFICATION_SUCCESS = 76,
    KYC_VERIFICATION_FAILED = 77,
    WITHDRAWAL_STATUS_UPDATED = 78, // Withdrawal wallet address verified / rejected.
    NEW_ITEM_ADDED = 79, // NEW NFT CREATED
    REFINANCE_REQUEST_CREATED = 80, // REFINANCE REQUEST CREATED

    // Syndicate events
    SYNDICATE_FUNDRAISING_EXPIRED = 81, // SYNDICATE FUNDRAISING EXPIRED
    SYNDICATE_COUNTER_EXPIRED = 82, // SYNDICATE COUNTER EXPIRED
    SYNDICATE_ACCEPTED_OTHER_TERMS = 83, // SYNDICATE ACCEPTED OTHER TERMS
    SYNDICATE_LOAN_REQUEST_CANCELED = 84, // SYNDICATE LOAN REQUEST CANCELED
    SYNDICATE_LOAN_ACCEPTED = 85, // SYNDICATE LOAN ACCEPTED
    SYNDICATE_LOAN_DEFAULT = 86, // SYNDICATE LOAN DEFAULT
    SYNDICATE_FUND_INVESTED = 87, // SYNDICATE FUND INVESTED
    SYNDICATE_AMOUNT_WITHDRAWN = 88, // SYNDICATE AMOUNT WITHDRAWN
    SYNDICATE_POOL_FULLY_FUNDED = 89, // SYNDICATE POOL FULLY FUNDED
    SYNDICATE_LOAN_INSTALLMENT_PAYMENT_CONFIRMATION = 90, // SYNDICATE LOAN INSTALLMENT PAYMENT CONFIRMATION
    SYNDICATE_LOAN_REPAID = 91, // SYNDICATE LOAN REPAID
    SYNDICATE_MANAGER_CANCELLED = 92, // SYNDICATE MANAGER CANCELLED
    SYNDICATE_PARENT_LOAN_REPAID = 95, // SYNDICATE PARENT LOAN REPAID (refinance pool closed)
    SYNDICATE_PARENT_LOAN_DEFAULTED = 96, // SYNDICATE PARENT LOAN DEFAULTED (refinance pool closed)
    SYNDICATE_LOAN_FORECLOSED = 100, // SYNDICATE LOAN FORECLOSED BY POOL MANAGER
    SYNDICATE_PLATFORM_CANCELLED = 101, // SYNDICATE POOL CANCELLED BY PLATFORM
    SYNDICATE_LOAN_FORECLOSED_MANAGER = 103, // To pool manager, when their foreclosure of the defaulted syndicate loan went through.

    // Custody fee events
    CUSTODY_FEE_OVERDUE = 93, // To item owner, when the item's custody fee is overdue.

    // Asset deposit events
    DEPOSIT_STATUS_UPDATED = 94, // To depositor, when ops moves their deposit through custody.

    // Admin freeze events
    NFT_FROZEN = 97, // To item owner, when admin freezes the item.
    NFT_UNFROZEN = 98, // To item owner, when admin unfreezes the item.

    // Referral events
    INTRODUCER_COMMISSION_EARNED = 99, // To introducer, when a referred user's action pays them a commission.

    // Installment auto-payment events
    AUTO_PAYMENT_FAILED = 102, // To borrower, when autopay could not pay an installment and they must pay it manually.

    // Community events
    USER_COMMUNITY_UPDATED = 104, // To the user, when the RealWorld team adds, moves or removes them from a community.
}

export const ADMIN_NOTIFICATIONS = [
    NotificationEvent.BLOCKED, //2
    NotificationEvent.UNBLOCKED, //3
];

export const LENDER_NOTIFICATIONS = [
    NotificationEvent.LENDING_AMOUNT_REPAID, //4
    NotificationEvent.BORROWER_ACCEPT_COUNTER, //8
    NotificationEvent.BORROWER_RECOUNTER_OFFER, //9
    NotificationEvent.BORROWER_ACCEPT_RECOUNTER, //13
    NotificationEvent.LOAN_DEFAULTED, //30
    NotificationEvent.LOAN_BID_APPROVED, //35
    NotificationEvent.BID_RECEIVED_FOR_FORECLOSED_NFT ,//38
    // NotificationEvent.LENDER_UPDATE_OFFER, //53 - moved to BORROWER_NOTIFICATIONS: the receiver is the borrower
    // NotificationEvent.LENDER_CANCELLED_OFFER, //55 - moved to BORROWER_NOTIFICATIONS: the receiver is the borrower
    NotificationEvent.BORROWER_UPDATE_OFFER, //52
    NotificationEvent.BORROWER_CANCELLED_OFFER, //54
    NotificationEvent.LOAN_REPAID_VIA_REFINANCE, //63
    NotificationEvent.REFINANCE_LOAN_ACTIVATED,  //64
    NotificationEvent.REFINANCE_AMOUNT_INSUFFICIENT_TO_LENDER, // 74
    NotificationEvent.LOAN_REQUEST_BID_ACCEPTANCE_FAILED, // 41
    NotificationEvent.LOAN_INSTALLMENT_PAYMENT_CONFIRMATION, //61 - sent to the lender when the borrower pays an installment
];

export const BORROWER_NOTIFICATIONS = [
    NotificationEvent.LOAN_FORECLOSED, //5
    NotificationEvent.LENDER_ACCEPTED_LOAN_REQUEST, //6
    NotificationEvent.LENDER_COUNTER_OFFER, //7
    NotificationEvent.LENDER_ACCEPT_RECOUNTER, //10
    NotificationEvent.REMINDER_70_PERCENT_DUE, //11
    NotificationEvent.LENDER_RECOUNTER_OFFER, //12
    NotificationEvent.REMINDER_24_HOURS_DUE, //15
    NotificationEvent.REMINDER_90_PERCENT_DUE, //16
    NotificationEvent.FORECLOSE_SUCCESS,//29
    NotificationEvent.LOAN_DEFAULTED_NOTIFICATION_TO_BORROWER, //31
    NotificationEvent.LOAN_BID_APPROVED_NOTIFICATION_TO_OWNER,//36
    NotificationEvent.BULK_LOAN_BID_APPROVED_NOTIFICATION_TO_OWNER, //45
    NotificationEvent.BULK_LOAN_BID_APPROVED, // 44
    NotificationEvent.LOAN_INSTALLMENT_DUE_REMINDER, //60
    // NotificationEvent.LOAN_INSTALLMENT_PAYMENT_CONFIRMATION, //61 - moved to LENDER_NOTIFICATIONS: the receiver is the lender
    NotificationEvent.LOAN_REFINANCED, //62
    NotificationEvent.REFINANCE_AMOUNT_INSUFFICIENT_TO_BORROWER, // 75
    NotificationEvent.LENDER_UPDATE_OFFER, //53 - sent to the borrower when the lender updates their counter offer
    NotificationEvent.LENDER_CANCELLED_OFFER, //55 - sent to the borrower when the lender cancels their counter offer
    NotificationEvent.AUTO_PAYMENT_FAILED, //102 - opens the loan page so the borrower can pay manually
];

export const OTHER_NOTIFICATONS = [
    NotificationEvent.ITEM_PURCHASED, //1
    NotificationEvent.ITEM_TRANSFERRED, //14
    NotificationEvent.BID_RECEIVED, //17
    NotificationEvent.REVISED_BID_RECEIVED, //18
    NotificationEvent.BID_CANCELLED, //19
    NotificationEvent.BID_APPROVED, //20
    NotificationEvent.BID_APPROVED_NOTIFICATION_TO_SELLER, //21
    NotificationEvent.BID_SUBMITTED, //22
    NotificationEvent.REVISED_BID_SUBMITTED, //23
    NotificationEvent.BID_CANCELLED_NOTIFICATION_TO_SELLER, //24
    NotificationEvent.DELIVERY_REQUEST_SENT, //25
    NotificationEvent.DELIVERY_REQUEST_RECEIVED,//26
    NotificationEvent.DELIVERY_REQUEST_UPDATED,//27
    NotificationEvent.DELIVERY_REQUEST_CANCELLED_USER,//39
    NotificationEvent.LOAN_OFFER_RECEIVED, //32
    NotificationEvent.REVISED_LOAN_BID_RECEIVED, //34
    NotificationEvent.LOAN_OFFER_CREATED, //33
    NotificationEvent.LOAN_BID_CANCELLED, //37
    NotificationEvent.BID_FAILED, //40
    NotificationEvent.BID_CANCELLED_DUE_TO_OTHER_ACCEPTANCE, //50
    NotificationEvent.NEW_ITEM_ADDED, //79
    NotificationEvent.REFINANCE_REQUEST_CREATED, //80
    NotificationEvent.OWNER_CANCELLED_LOAN_OFFER, //49
    NotificationEvent.CUSTODY_FEE_OVERDUE, //93
    NotificationEvent.NFT_FROZEN, //97
    NotificationEvent.NFT_UNFROZEN, //98
    NotificationEvent.INTRODUCER_COMMISSION_EARNED, //99

];

/**
 * Owner-side bid events. They open the NFT details page with `?focus=bids`, which scrolls to and
 * highlights the bids list.
 */
export const BID_FOCUS_NOTIFICATIONS = [
    NotificationEvent.BID_RECEIVED, //17
    NotificationEvent.REVISED_BID_RECEIVED, //18
    NotificationEvent.BID_CANCELLED_NOTIFICATION_TO_SELLER, //24
];

/**
 * Owner-side loan offer events. They open the NFT details page with `?focus=loan-offers`.
 * A new offer on an asset is sent as 33; 32 is kept for completeness but carries no target today,
 * so redirectNotifications returns before it gets here.
 */
export const LOAN_OFFER_FOCUS_NOTIFICATIONS = [
    NotificationEvent.LOAN_OFFER_RECEIVED, //32
    NotificationEvent.LOAN_OFFER_CREATED, //33
    NotificationEvent.REVISED_LOAN_BID_RECEIVED, //34
    NotificationEvent.LOAN_BID_CANCELLED, //37
];

export const BULK_OPEN_LOAN_OFFER_NOTIFICATION = [
    NotificationEvent.COUNTER_REQUEST_OPEN_LOAN_OFFER,//43
    NotificationEvent.BULK_LOAN_BID_CANCELLED, //46
    NotificationEvent.REVISED_BULK_LOAN_BID_RECEIVED,//47
    NotificationEvent.LENDER_CREATED_A_BULK_LOAN_OFFER,//48
    // NotificationEvent.OWNER_CANCELLED_LOAN_OFFER, //49
    NotificationEvent.LENDER_CANCELLED_OPEN_OFFER, //59
    NotificationEvent.LENDER_UPDATED_OPEN_OFFER, //57
    NotificationEvent.BORROWER_CANCELLED_OPEN_OFFER, //58
    NotificationEvent.BORROWER_UPDATED_OPEN_OFFER, //56
]

export const FUND_NOTIFICATION = [
    NotificationEvent.FUND_RECEIVED //51
]

export const RESELLNOTIFICATION =[
    NotificationEvent.BUYER_COUNTER_OFFER, //66
    NotificationEvent.BUYER_RECOUNTER_OFFER, //67
    NotificationEvent.SELLER_RECOUNTER_OFFER,//68
    NotificationEvent.UPDATE_SELL_COUNTER_OFFER, //69
    NotificationEvent.CANCEL_SELL_COUNTER_OFFER,  //70 
]

export const BORROWANDLEND =[
    NotificationEvent.LOAN_SOLD, // 72
    NotificationEvent.LOAN_ASSIGNED, //73
]

export const KYC_NOTIFICATION =[
    NotificationEvent.KYC_VERIFICATION_SUCCESS, //76
    NotificationEvent.KYC_VERIFICATION_FAILED //77
]

/**
 * Deposit lifecycle notifications. These open the Deposits page rather than an item detail —
 * the asset has no NFT to link to until the deposit reaches `minted`.
 */
export const DEPOSIT_NOTIFICATIONS = [
    NotificationEvent.DEPOSIT_STATUS_UPDATED //94
]

/**
 * Push-banner card meta for loan, refinance, resale, sale, sell-order, syndicate, delivery,
 * item-status, KYC and referral events.
 * `status` renders as a coloured text pill (no icon) whose colour comes from `variant`.
 * Events not listed here keep the legacy banner.
 */
export type PushNotificationVariant = 'live' | 'request' | 'refinance' | 'resale' | 'sale' | 'sell-order'
    | 'fundraising' | 'funded' | 'expired' | 'defaulted' | 'closed'
    | 'repaid' | 'failed' | 'delivery' | 'overdue' | 'frozen' | 'verified';

export interface PushNotificationMeta {
    title: string;
    status: string;
    variant: PushNotificationVariant;
    action: string;
    // 'kyc' shows a plain KYC tile instead of the asset image (KYC events carry no asset).
    // 'icon' shows the bell icon, for account / wallet events that have no asset either.
    thumb?: 'kyc' | 'icon';
}

/** One push banner on screen (or waiting in the queue); `meta` null renders the legacy banner. */
export interface PushNotificationItem {
    key: number;
    notification: any;
    meta: PushNotificationMeta | null;
    timeout: ReturnType<typeof setTimeout> | null;
    // Full auto-hide time (ms) picked when the card is shown: shorter while others are queued.
    // The template binds it to the timer bar's animation-duration.
    duration: number;
    // Auto-hide time still left (ms) and when the current countdown started; hover pauses it.
    remaining: number;
    startedAt: number;
    // Click opens the same page as the bell row; false when the payload has nowhere to go.
    canRedirect: boolean;
}

const LIVE = { status: 'Live', variant: 'live', action: 'View loan' } as const;
const REQUEST = { status: 'Request', variant: 'request', action: 'View loan' } as const;
const REFINANCE = { status: 'Refinance', variant: 'refinance', action: 'View loan' } as const;
const RESALE = { status: 'Resale', variant: 'resale', action: 'View loan' } as const;
const SALE = { status: 'Sale', variant: 'sale', action: 'View item' } as const;
const SELL_ORDER = { status: 'Sell order', variant: 'sell-order', action: 'View item' } as const;

export const PUSH_NOTIFICATION_META: Partial<Record<NotificationEvent, PushNotificationMeta>> = {
    // Live loan
    [NotificationEvent.LENDER_ACCEPTED_LOAN_REQUEST]: { title: 'Loan request accepted', ...LIVE },
    // [NotificationEvent.BORROWER_ACCEPT_COUNTER]: { title: 'Counter offer accepted', ...LIVE },
    [NotificationEvent.BORROWER_ACCEPT_COUNTER]: { title: 'Your counteroffer was accepted', ...LIVE },
    // [NotificationEvent.LENDER_ACCEPT_RECOUNTER]: { title: 'Re-counter accepted', ...LIVE },
    [NotificationEvent.LENDER_ACCEPT_RECOUNTER]: { title: 'Your re-counteroffer was accepted', ...LIVE },
    // [NotificationEvent.BORROWER_ACCEPT_RECOUNTER]: { title: 'Re-counter accepted', ...LIVE },
    [NotificationEvent.BORROWER_ACCEPT_RECOUNTER]: { title: 'Your re-counteroffer was accepted', ...LIVE },
    // [NotificationEvent.LOAN_BID_APPROVED]: { title: 'Loan offer approved', ...LIVE },
    [NotificationEvent.LOAN_BID_APPROVED]: { title: 'Your loan offer was accepted', ...LIVE },
    // [NotificationEvent.LOAN_BID_APPROVED_NOTIFICATION_TO_OWNER]: { title: 'Loan offer approved', ...LIVE },
    [NotificationEvent.LOAN_BID_APPROVED_NOTIFICATION_TO_OWNER]: { title: 'You accepted a loan offer', ...LIVE },
    // [NotificationEvent.BULK_LOAN_BID_APPROVED]: { title: 'Loan offer approved', ...LIVE },
    [NotificationEvent.BULK_LOAN_BID_APPROVED]: { title: 'Your loan offer was accepted', ...LIVE },
    // [NotificationEvent.BULK_LOAN_BID_APPROVED_NOTIFICATION_TO_OWNER]: { title: 'Loan offer approved', ...LIVE },
    [NotificationEvent.BULK_LOAN_BID_APPROVED_NOTIFICATION_TO_OWNER]: { title: 'You accepted a loan offer', ...LIVE },
    [NotificationEvent.REMINDER_70_PERCENT_DUE]: { title: 'Repayment reminder', ...LIVE },
    [NotificationEvent.REMINDER_90_PERCENT_DUE]: { title: 'Repayment reminder', ...LIVE },
    [NotificationEvent.REMINDER_24_HOURS_DUE]: { title: 'Repayment due in 24 hours', ...LIVE },
    [NotificationEvent.REMINDER_50_PERCENT_DUE]: { title: 'Repayment reminder', ...LIVE },
    // [NotificationEvent.LOAN_INSTALLMENT_DUE_REMINDER]: { title: 'Installment due', ...LIVE },
    [NotificationEvent.LOAN_INSTALLMENT_DUE_REMINDER]: { title: 'Upcoming installment', ...LIVE },
    // [NotificationEvent.LOAN_INSTALLMENT_PAYMENT_CONFIRMATION]: { title: 'Installment paid', ...LIVE },
    [NotificationEvent.LOAN_INSTALLMENT_PAYMENT_CONFIRMATION]: { title: 'Repayment received', ...LIVE },
    [NotificationEvent.AUTO_PAYMENT_FAILED]: { title: 'Autopay failed: pay manually', status: 'Failed', variant: 'failed', action: 'View loan' },

    // Loan request / offers / counters
    // [NotificationEvent.LENDER_COUNTER_OFFER]: { title: 'Counter offer received', ...REQUEST },
    [NotificationEvent.LENDER_COUNTER_OFFER]: { title: 'New counteroffer', ...REQUEST },
    // [NotificationEvent.BORROWER_RECOUNTER_OFFER]: { title: 'Re-counter offer received', ...REQUEST },
    [NotificationEvent.BORROWER_RECOUNTER_OFFER]: { title: 'New re-counteroffer', ...REQUEST },
    // [NotificationEvent.LENDER_RECOUNTER_OFFER]: { title: 'Re-counter offer received', ...REQUEST },
    [NotificationEvent.LENDER_RECOUNTER_OFFER]: { title: 'New re-counteroffer', ...REQUEST },
    // [NotificationEvent.BORROWER_UPDATE_OFFER]: { title: 'Counter offer updated', ...REQUEST },
    [NotificationEvent.BORROWER_UPDATE_OFFER]: { title: 'Counteroffer updated', ...REQUEST },
    // [NotificationEvent.LENDER_UPDATE_OFFER]: { title: 'Counter offer updated', ...REQUEST },
    [NotificationEvent.LENDER_UPDATE_OFFER]: { title: 'Counteroffer updated', ...REQUEST },
    // [NotificationEvent.BORROWER_CANCELLED_OFFER]: { title: 'Counter offer cancelled', ...REQUEST },
    [NotificationEvent.BORROWER_CANCELLED_OFFER]: { title: 'Counteroffer cancelled', ...REQUEST },
    // [NotificationEvent.LENDER_CANCELLED_OFFER]: { title: 'Counter offer cancelled', ...REQUEST },
    [NotificationEvent.LENDER_CANCELLED_OFFER]: { title: 'Counteroffer cancelled', ...REQUEST },
    // [NotificationEvent.LOAN_OFFER_RECEIVED]: { title: 'Loan offer received', ...REQUEST, action: 'View item' },
    [NotificationEvent.LOAN_OFFER_RECEIVED]: { title: 'New loan offer', ...REQUEST, action: 'View item' },
    // [NotificationEvent.LOAN_OFFER_CREATED]: { title: 'Loan offer created', ...REQUEST, action: 'View item' },
    [NotificationEvent.LOAN_OFFER_CREATED]: { title: 'New loan offer', ...REQUEST, action: 'View item' },
    // [NotificationEvent.REVISED_LOAN_BID_RECEIVED]: { title: 'Loan offer revised', ...REQUEST, action: 'View item' },
    [NotificationEvent.REVISED_LOAN_BID_RECEIVED]: { title: 'Loan offer updated', ...REQUEST, action: 'View item' },
    // [NotificationEvent.LOAN_BID_CANCELLED]: { title: 'Loan offer cancelled', ...REQUEST, action: 'View item' },
    [NotificationEvent.LOAN_BID_CANCELLED]: { title: 'Loan offer withdrawn', ...REQUEST, action: 'View item' },
    // [NotificationEvent.COUNTER_REQUEST_OPEN_LOAN_OFFER]: { title: 'Counter request received', ...REQUEST },
    [NotificationEvent.COUNTER_REQUEST_OPEN_LOAN_OFFER]: { title: 'New counteroffer', ...REQUEST },
    // [NotificationEvent.BULK_LOAN_BID_CANCELLED]: { title: 'Open offer cancelled', ...REQUEST },
    [NotificationEvent.BULK_LOAN_BID_CANCELLED]: { title: 'Loan offer withdrawn', ...REQUEST },
    // [NotificationEvent.REVISED_BULK_LOAN_BID_RECEIVED]: { title: 'Open offer revised', ...REQUEST },
    [NotificationEvent.REVISED_BULK_LOAN_BID_RECEIVED]: { title: 'Loan offer updated', ...REQUEST },
    // [NotificationEvent.LENDER_CREATED_A_BULK_LOAN_OFFER]: { title: 'New open offer', ...REQUEST },
    [NotificationEvent.LENDER_CREATED_A_BULK_LOAN_OFFER]: { title: 'New loan offer on multiple items', ...REQUEST },
    // [NotificationEvent.OWNER_CANCELLED_LOAN_OFFER]: { title: 'Loan request cancelled', ...REQUEST, action: 'View item' },
    [NotificationEvent.OWNER_CANCELLED_LOAN_OFFER]: { title: 'Your loan offer was declined', ...REQUEST, action: 'View item' },
    // [NotificationEvent.BORROWER_UPDATED_OPEN_OFFER]: { title: 'Open offer counter updated', ...REQUEST },
    [NotificationEvent.BORROWER_UPDATED_OPEN_OFFER]: { title: 'Counteroffer updated', ...REQUEST },
    // [NotificationEvent.LENDER_UPDATED_OPEN_OFFER]: { title: 'Open offer counter updated', ...REQUEST },
    [NotificationEvent.LENDER_UPDATED_OPEN_OFFER]: { title: 'Counteroffer updated', ...REQUEST },
    // [NotificationEvent.BORROWER_CANCELLED_OPEN_OFFER]: { title: 'Open offer counter cancelled', ...REQUEST },
    [NotificationEvent.BORROWER_CANCELLED_OPEN_OFFER]: { title: 'Counteroffer cancelled', ...REQUEST },
    // [NotificationEvent.LENDER_CANCELLED_OPEN_OFFER]: { title: 'Open offer counter cancelled', ...REQUEST },
    [NotificationEvent.LENDER_CANCELLED_OPEN_OFFER]: { title: 'Counteroffer cancelled', ...REQUEST },
    // [NotificationEvent.LOAN_REQUEST_BID_ACCEPTANCE_FAILED]: { title: 'Loan acceptance failed', status: 'Failed', variant: 'failed', action: 'View loan' },
    [NotificationEvent.LOAN_REQUEST_BID_ACCEPTANCE_FAILED]: { title: 'Acceptance failed: low balance', status: 'Failed', variant: 'failed', action: 'View loan' },
    // [NotificationEvent.LOAN_BID_ACCEPTANCE_FAILED]: { title: 'Loan acceptance failed', status: 'Failed', variant: 'failed', action: 'View loan' },
    [NotificationEvent.LOAN_BID_ACCEPTANCE_FAILED]: { title: 'Acceptance failed: low balance', status: 'Failed', variant: 'failed', action: 'View loan' },

    // Refinance
    [NotificationEvent.REFINANCE_REQUEST_CREATED]: { title: 'Refinance request created', ...REFINANCE },
    [NotificationEvent.LOAN_REFINANCED]: { title: 'Loan refinanced', ...REFINANCE },
    [NotificationEvent.LOAN_REPAID_VIA_REFINANCE]: { title: 'Loan repaid via refinance', ...REFINANCE },
    // [NotificationEvent.REFINANCE_LOAN_ACTIVATED]: { title: 'Refinance loan activated', ...REFINANCE },
    [NotificationEvent.REFINANCE_LOAN_ACTIVATED]: { title: 'Loan refinanced', ...REFINANCE },
    // [NotificationEvent.REFINANCE_AMOUNT_INSUFFICIENT_TO_LENDER]: { title: 'Refinance amount insufficient', ...REFINANCE },
    [NotificationEvent.REFINANCE_AMOUNT_INSUFFICIENT_TO_LENDER]: { title: 'Refinance amount too low', ...REFINANCE },
    // [NotificationEvent.REFINANCE_AMOUNT_INSUFFICIENT_TO_BORROWER]: { title: 'Refinance amount insufficient', ...REFINANCE },
    [NotificationEvent.REFINANCE_AMOUNT_INSUFFICIENT_TO_BORROWER]: { title: 'Refinance amount too low', ...REFINANCE },

    // Resale (loan position sale)
    // [NotificationEvent.BUYER_COUNTER_OFFER]: { title: 'Resale counter offer', ...RESALE },
    [NotificationEvent.BUYER_COUNTER_OFFER]: { title: 'New counteroffer on loan sale', ...RESALE },
    // [NotificationEvent.BUYER_RECOUNTER_OFFER]: { title: 'Resale re-counter offer', ...RESALE },
    [NotificationEvent.BUYER_RECOUNTER_OFFER]: { title: 'New re-counteroffer on loan sale', ...RESALE },
    // [NotificationEvent.SELLER_RECOUNTER_OFFER]: { title: 'Resale re-counter offer', ...RESALE },
    [NotificationEvent.SELLER_RECOUNTER_OFFER]: { title: 'New re-counteroffer on loan sale', ...RESALE },
    // [NotificationEvent.UPDATE_SELL_COUNTER_OFFER]: { title: 'Resale counter updated', ...RESALE },
    [NotificationEvent.UPDATE_SELL_COUNTER_OFFER]: { title: 'Loan sale counteroffer updated', ...RESALE },
    // [NotificationEvent.CANCEL_SELL_COUNTER_OFFER]: { title: 'Resale counter cancelled', ...RESALE },
    [NotificationEvent.CANCEL_SELL_COUNTER_OFFER]: { title: 'Loan sale counteroffer cancelled', ...RESALE },
    // [NotificationEvent.LOAN_LENDER_CHANGED]: { title: 'Loan lender changed', ...RESALE },
    [NotificationEvent.LOAN_LENDER_CHANGED]: { title: 'Your lender has changed', ...RESALE },
    [NotificationEvent.LOAN_SOLD]: { title: 'Loan sold', ...RESALE },
    // [NotificationEvent.LOAN_ASSIGNED]: { title: 'Loan assigned', ...RESALE },
    [NotificationEvent.LOAN_ASSIGNED]: { title: 'Loan acquired', ...RESALE },

    // Sale
    [NotificationEvent.ITEM_PURCHASED]: { title: 'Item sold', ...SALE },
    // [NotificationEvent.ITEM_TRANSFERRED]: { title: 'Item transferred', ...SALE },
    [NotificationEvent.ITEM_TRANSFERRED]: { title: 'Item received', ...SALE },
    // [NotificationEvent.BID_APPROVED]: { title: 'Bid approved', ...SALE },
    [NotificationEvent.BID_APPROVED]: { title: 'Your bid was accepted', ...SALE },
    // [NotificationEvent.BID_APPROVED_NOTIFICATION_TO_SELLER]: { title: 'Bid approved', ...SALE },
    [NotificationEvent.BID_APPROVED_NOTIFICATION_TO_SELLER]: { title: 'You accepted a bid', ...SALE },
    // [NotificationEvent.BID_FAILED]: { title: 'Bid failed', ...SALE },
    [NotificationEvent.BID_FAILED]: { title: 'Bid acceptance failed', ...SALE },
    // [NotificationEvent.BID_CANCELLED_DUE_TO_OTHER_ACCEPTANCE]: { title: 'Bid closed', ...SALE },
    [NotificationEvent.BID_CANCELLED_DUE_TO_OTHER_ACCEPTANCE]: { title: 'Another bid was accepted', ...SALE },

    // Sell order (bids on a listing)
    [NotificationEvent.BID_RECEIVED]: { title: 'Bid received', ...SELL_ORDER },
    // [NotificationEvent.REVISED_BID_RECEIVED]: { title: 'Bid revised', ...SELL_ORDER },
    [NotificationEvent.REVISED_BID_RECEIVED]: { title: 'Revised bid received', ...SELL_ORDER },
    // [NotificationEvent.BID_CANCELLED]: { title: 'Bid cancelled', ...SELL_ORDER },
    [NotificationEvent.BID_CANCELLED]: { title: 'Your bid was cancelled', ...SELL_ORDER },
    [NotificationEvent.BID_SUBMITTED]: { title: 'Bid submitted', ...SELL_ORDER },
    // [NotificationEvent.REVISED_BID_SUBMITTED]: { title: 'Bid revised', ...SELL_ORDER },
    [NotificationEvent.REVISED_BID_SUBMITTED]: { title: 'Bid updated', ...SELL_ORDER },
    // [NotificationEvent.BID_CANCELLED_NOTIFICATION_TO_SELLER]: { title: 'Bid cancelled', ...SELL_ORDER },
    [NotificationEvent.BID_CANCELLED_NOTIFICATION_TO_SELLER]: { title: 'Bid withdrawn', ...SELL_ORDER },
    // [NotificationEvent.BID_RECEIVED_FOR_FORECLOSED_NFT]: { title: 'Bid received', ...SELL_ORDER, action: 'View loan' },
    [NotificationEvent.BID_RECEIVED_FOR_FORECLOSED_NFT]: { title: 'Bid on foreclosed item', ...SELL_ORDER, action: 'View loan' },

    // Syndicate pool - fundraising
    [NotificationEvent.SYNDICATE_POOL_FULLY_FUNDED]: { title: 'Syndicate fully funded', status: '100%', variant: 'funded', action: 'View syndicate' },
    [NotificationEvent.SYNDICATE_FUND_INVESTED]: { title: 'Funds added to pool', status: 'Fundraising', variant: 'fundraising', action: 'View syndicate' },
    [NotificationEvent.SYNDICATE_AMOUNT_WITHDRAWN]: { title: 'Funds withdrawn', status: 'Withdrawn', variant: 'fundraising', action: 'View syndicate' },
    [NotificationEvent.SYNDICATE_FUNDRAISING_EXPIRED]: { title: 'Fundraising expired', status: 'Expired', variant: 'expired', action: 'View syndicate' },
    [NotificationEvent.SYNDICATE_COUNTER_EXPIRED]: { title: 'Counter period expired', status: 'Expired', variant: 'expired', action: 'View syndicate' },

    // Syndicate pool - live loan
    // [NotificationEvent.SYNDICATE_LOAN_ACCEPTED]: { title: 'Syndicate loan live', status: 'Live', variant: 'live', action: 'View loan' },
    [NotificationEvent.SYNDICATE_LOAN_ACCEPTED]: { title: 'Syndicate loan accepted', status: 'Live', variant: 'live', action: 'View loan' },
    // [NotificationEvent.SYNDICATE_LOAN_INSTALLMENT_PAYMENT_CONFIRMATION]: { title: 'Installment received', status: 'Repayment', variant: 'live', action: 'View loan' },
    [NotificationEvent.SYNDICATE_LOAN_INSTALLMENT_PAYMENT_CONFIRMATION]: { title: 'Syndicate repayment received', status: 'Repayment', variant: 'live', action: 'View loan' },
    [NotificationEvent.SYNDICATE_LOAN_REPAID]: { title: 'Syndicate loan repaid', status: 'Repaid', variant: 'funded', action: 'View loan' },
    [NotificationEvent.SYNDICATE_LOAN_DEFAULT]: { title: 'Syndicate loan defaulted', status: 'Defaulted', variant: 'defaulted', action: 'View loan' },
    [NotificationEvent.SYNDICATE_LOAN_FORECLOSED]: { title: 'Syndicate loan foreclosed', status: 'Foreclosed', variant: 'defaulted', action: 'View loan' },
    [NotificationEvent.SYNDICATE_LOAN_FORECLOSED_MANAGER]: { title: 'Syndicate loan foreclosed', status: 'Foreclosed', variant: 'defaulted', action: 'View loan' },

    // Syndicate pool - closed
    // [NotificationEvent.SYNDICATE_ACCEPTED_OTHER_TERMS]: { title: 'Syndicate closed', status: 'Closed', variant: 'closed', action: 'View syndicate' },
    [NotificationEvent.SYNDICATE_ACCEPTED_OTHER_TERMS]: { title: 'Pool closed: other terms accepted', status: 'Closed', variant: 'closed', action: 'View syndicate' },
    // [NotificationEvent.SYNDICATE_LOAN_REQUEST_CANCELED]: { title: 'Syndicate cancelled', status: 'Cancelled', variant: 'closed', action: 'View syndicate' },
    [NotificationEvent.SYNDICATE_LOAN_REQUEST_CANCELED]: { title: 'Pool cancelled by borrower', status: 'Cancelled', variant: 'closed', action: 'View syndicate' },
    // [NotificationEvent.SYNDICATE_MANAGER_CANCELLED]: { title: 'Syndicate cancelled', status: 'Cancelled', variant: 'closed', action: 'View syndicate' },
    [NotificationEvent.SYNDICATE_MANAGER_CANCELLED]: { title: 'Pool cancelled by manager', status: 'Cancelled', variant: 'closed', action: 'View syndicate' },
    // [NotificationEvent.SYNDICATE_PLATFORM_CANCELLED]: { title: 'Syndicate cancelled', status: 'Cancelled', variant: 'closed', action: 'View syndicate' },
    [NotificationEvent.SYNDICATE_PLATFORM_CANCELLED]: { title: 'Pool cancelled by platform', status: 'Cancelled', variant: 'closed', action: 'View syndicate' },
    [NotificationEvent.SYNDICATE_PARENT_LOAN_REPAID]: { title: 'Refinance pool closed', status: 'Closed', variant: 'closed', action: 'View syndicate' },
    [NotificationEvent.SYNDICATE_PARENT_LOAN_DEFAULTED]: { title: 'Refinance pool closed', status: 'Closed', variant: 'closed', action: 'View syndicate' },

    // Loan outcome
    [NotificationEvent.LENDING_AMOUNT_REPAID]: { title: 'Loan repaid', status: 'Repaid', variant: 'repaid', action: 'View loan' },
    [NotificationEvent.LOAN_FORECLOSED]: { title: 'Loan foreclosed', status: 'Foreclosed', variant: 'defaulted', action: 'View loan' },
    [NotificationEvent.FORECLOSE_SUCCESS]: { title: 'Loan foreclosed', status: 'Foreclosed', variant: 'defaulted', action: 'View loan' },
    [NotificationEvent.LOAN_DEFAULTED]: { title: 'Loan defaulted', status: 'Defaulted', variant: 'defaulted', action: 'View loan' },
    [NotificationEvent.LOAN_DEFAULTED_NOTIFICATION_TO_BORROWER]: { title: 'Loan defaulted', status: 'Defaulted', variant: 'defaulted', action: 'View loan' },

    // Delivery
    [NotificationEvent.DELIVERY_REQUEST_SENT]: { title: 'Delivery requested', status: 'Delivery', variant: 'delivery', action: 'View item' },
    [NotificationEvent.DELIVERY_REQUEST_RECEIVED]: { title: 'Delivery request received', status: 'Delivery', variant: 'delivery', action: 'View item' },
    [NotificationEvent.DELIVERY_REQUEST_UPDATED]: { title: 'Delivery updated', status: 'Delivery', variant: 'delivery', action: 'View item' },
    [NotificationEvent.DELIVERY_REQUEST_CANCELLED]: { title: 'Delivery cancellation request', status: 'Delivery', variant: 'delivery', action: 'View item' },
    [NotificationEvent.DELIVERY_REQUEST_CANCELLED_USER]: { title: 'Delivery cancelled', status: 'Delivery', variant: 'delivery', action: 'View item' },

    // Item status
    [NotificationEvent.NEW_ITEM_ADDED]: { title: 'New asset added', status: 'New', variant: 'live', action: 'View wallet' },
    [NotificationEvent.CUSTODY_FEE_OVERDUE]: { title: 'Custody fee overdue', status: 'Overdue', variant: 'overdue', action: 'View item' },
    [NotificationEvent.NFT_FROZEN]: { title: 'Item frozen', status: 'Frozen', variant: 'frozen', action: 'View item' },
    [NotificationEvent.NFT_UNFROZEN]: { title: 'Item unfrozen', status: 'Unfrozen', variant: 'verified', action: 'View item' },

    // Account and referrals
    // [NotificationEvent.KYC_VERIFICATION_SUCCESS]: { title: 'Identity verified', status: 'Verified', variant: 'verified', action: 'View profile', thumb: 'kyc' },
    [NotificationEvent.KYC_VERIFICATION_SUCCESS]: { title: 'KYC verified', status: 'Verified', variant: 'verified', action: 'View profile', thumb: 'kyc' },
    // [NotificationEvent.KYC_VERIFICATION_FAILED]: { title: 'Identity verification failed', status: 'Failed', variant: 'failed', action: 'Try again', thumb: 'kyc' },
    [NotificationEvent.KYC_VERIFICATION_FAILED]: { title: 'KYC verification failed', status: 'Failed', variant: 'failed', action: 'Try again', thumb: 'kyc' },
    [NotificationEvent.INTRODUCER_COMMISSION_EARNED]: { title: 'Referral commission earned', status: 'Commission', variant: 'repaid', action: 'View item' },
    [NotificationEvent.BLOCKED]: { title: 'Account blocked', status: 'Blocked', variant: 'defaulted', action: '', thumb: 'icon' },
    [NotificationEvent.UNBLOCKED]: { title: 'Account unblocked', status: 'Active', variant: 'verified', action: '', thumb: 'icon' },
    [NotificationEvent.FUND_RECEIVED]: { title: 'Funds received', status: 'Received', variant: 'repaid', action: 'View transaction', thumb: 'icon' },
    // Verified or rejected is only in the message, so the pill stays neutral.
    // [NotificationEvent.WITHDRAWAL_STATUS_UPDATED]: { title: 'Withdrawal wallet update', status: 'Wallet', variant: 'closed', action: '', thumb: 'icon' },
    [NotificationEvent.WITHDRAWAL_STATUS_UPDATED]: { title: 'Withdrawal wallet status', status: 'Wallet', variant: 'closed', action: '', thumb: 'icon' },
    // Added, moved or removed is only in the message, so the pill stays neutral.
    [NotificationEvent.USER_COMMUNITY_UPDATED]: { title: 'Community membership', status: 'Community', variant: 'closed', action: '', thumb: 'icon' },
};

/**
 * Admin collection delete emits straight to the socket (not through the notification store), so the
 * payload has no `event_type` - only `message_type`. Matched by that in the header.
 */
export const COLLECTION_DELETED_MESSAGE_TYPE = 'COLLECTION DELETED';
export const COLLECTION_DELETED_PUSH_META: PushNotificationMeta = {
    title: 'Collection deleted', status: 'Deleted', variant: 'closed', action: '', thumb: 'icon',
};

export const SYNDICATELEND =[
    NotificationEvent.SYNDICATE_FUNDRAISING_EXPIRED, // 81
    NotificationEvent.SYNDICATE_COUNTER_EXPIRED, // 82
    NotificationEvent.SYNDICATE_ACCEPTED_OTHER_TERMS, // 83
    NotificationEvent.SYNDICATE_LOAN_REQUEST_CANCELED, // 84
    NotificationEvent.SYNDICATE_LOAN_ACCEPTED, // 85
    NotificationEvent.SYNDICATE_LOAN_DEFAULT, // 86
    NotificationEvent.SYNDICATE_FUND_INVESTED, // 87
    NotificationEvent.SYNDICATE_AMOUNT_WITHDRAWN, // 88
    NotificationEvent.SYNDICATE_POOL_FULLY_FUNDED, // 89
    NotificationEvent.SYNDICATE_MANAGER_CANCELLED, // 92
    NotificationEvent.SYNDICATE_PARENT_LOAN_REPAID, // 95
    NotificationEvent.SYNDICATE_PARENT_LOAN_DEFAULTED, // 96
    NotificationEvent.SYNDICATE_LOAN_FORECLOSED, // 100
    NotificationEvent.SYNDICATE_PLATFORM_CANCELLED, // 101
    NotificationEvent.SYNDICATE_LOAN_FORECLOSED_MANAGER, // 103
    NotificationEvent.SYNDICATE_LOAN_INSTALLMENT_PAYMENT_CONFIRMATION, // 90
    NotificationEvent.SYNDICATE_LOAN_REPAID, // 91
]